import { render } from "./StylesPanel.vue?vue&type=template&id=76e9d9ef&ts=true"
import script from "./StylesPanel.vue?vue&type=script&lang=ts"
export * from "./StylesPanel.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__